import { useTranslation } from 'react-i18next';
import type { Invitation } from '../types/signup.types';

interface SignupReadonlyFieldsProps {
  invitation: Invitation;
}

// Email (always) + department / jobRole metadata pulled from the verified
// invitation. The metadata block is MEDICAL_STAFF-only (US-SU-06: the ADMIN
// Role is invitation-email metadata and is no longer shown on this screen).
export const SignupReadonlyFields = ({ invitation }: SignupReadonlyFieldsProps) => {
  const { t } = useTranslation('auth');

  return (
    <>
      <div className="signup-page__field">
        <label className="login-page__label" htmlFor="inviteEmail">
          {t('signup.fields.email')}
        </label>
        <div className="login-page__input-wrap">
          <input
            id="inviteEmail"
            type="email"
            className="login-page__input signup-page__input-no-icon signup-page__readonly"
            value={invitation.email}
            readOnly
          />
        </div>
      </div>

      {invitation.accountType === 'MEDICAL_STAFF' && (
        <div className="signup-page__field">
          <p className="login-page__label" id="signupAssignmentLabel">
            {t('signup.fields.assignment')}
          </p>
          <div
            className="signup-page__meta"
            role="group"
            aria-labelledby="signupAssignmentLabel"
          >
            <span className="signup-page__meta-item">
              <span className="signup-page__meta-label">{t('signup.fields.department')}:</span>
              {invitation.department}
            </span>
            <span className="signup-page__meta-item">
              <span className="signup-page__meta-label">{t('signup.fields.jobRole')}:</span>
              {invitation.jobRole}
            </span>
          </div>
        </div>
      )}
    </>
  );
};
